import { injectReducer } from '../../../../../store/reducers'

export default (store) => ({
  onEnter: (nextState, replace) => {

  },
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const PaymentSuccessView = require('./containers/PaymentSuccessContainer').default
      const reducer = require('../../../modules/app').default

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'app', reducer })

      /*  Return getComponent   */
      cb(null, PaymentSuccessView)

    /* Webpack named bundle   */
    }, 'Application')
    
  }
})



// WEBPACK FOOTER //
// ./src/routes/Home/routes/Payment/PaymentSuccess/index.js